'use strict';

class HandControllerData {
    constructor() {
        this.handModelName = "controllerModelFBX";

        this.vive1Name = "Controller1";
        this.vive1MeshName = "Controller1_Mesh";
        this.vive1SaberName = "Controller1_Saber";

        this.vive2Name = "Controller2";
        this.vive2MeshName = "Controller2_Mesh";
        this.vive2SaberName = "Controller2_Saber";

        this.controllerGeometryLeft = new THREE.BufferGeometry();
        this.controllerMaterialLeft = new THREE.MeshStandardMaterial();

        this.controllerGeometryRight = new THREE.BufferGeometry();
        this.controllerMaterialRight = new THREE.MeshStandardMaterial();

        this.laser_visible = false;
        this.vive_available_left = false;
        this.vive_available_right = false;

        this.controllerMeshOffsetX = 0.04;
        this.controllerMeshOffsetZ = 0.07;

        this.handTrackingPositionOffsetY = 0.06;
        this.handTrackingPositionOffsetZ = 0.02;

        this.yAxisRotation = Math.PI / 2;
        this.leftControllerObjectOffset = new THREE.Vector3(-this.controllerMeshOffsetX + 0.005, -0.03, 0.02);
        this.rightControllerObjectOffset = new THREE.Vector3(this.controllerMeshOffsetX - 0.005, -0.03, 0.02);
        this.leftLineOffset = new THREE.Vector3(-this.controllerMeshOffsetX + 0.015, 0, 0.02);
        this.rightLineOffset = new THREE.Vector3(this.controllerMeshOffsetX - 0.015, 0, 0.02);
    }
}

export default HandControllerData;
